module.exports = {"meta":{"title":"Połączenie z Atende","description":"Połączenie z Atende"},"heading":"Połączenie Atende S.A. z Codeshine sp. z o.o."}